import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';

/**
 * @summary CarouselElement
 * @extends {AoflElement}
 */
@customElement('carousel-element')
class CarouselElement extends AoflElement {
  /**
   * Creates an instance of Carousel.
   */
  constructor() {
    super();
  }

  /**
   * @readonly
   */
  static is = 'carousel-element';

  @property({type: Object, attribute: true})
  config = {};

  @property({type: Number, attribute: false})
  selectedIndex = 0;

  interval = null;

  selectIndex(index, clearInterval) {
    this.selectedIndex = index;
    if (clearInterval) {
      this.clearInterval();
    }
  }

  nextItem(clearInterval) {
    if (clearInterval) {
      this.clearInterval();
    }

    let nextIndex = this.selectedIndex + 1;
    if (nextIndex > this.config.items.length - 1) {
      nextIndex = 0;
    }
    this.selectedIndex = nextIndex;
  }

  prevItem(clearInterval) {
    if (clearInterval) {
      this.clearInterval();
    }

    let nextIndex = this.selectedIndex - 1;
    if (nextIndex < 0) {
      nextIndex = this.config.items.length - 1;
    }
    this.selectedIndex = nextIndex;
  }

  connectedCallback() {
    super.connectedCallback();
    // this.interval = setInterval(() => this.nextItem(), 3000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.clearInterval();
  }

  clearInterval() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default CarouselElement;
